import React from "react";
import MarketingPage from "./MarketingPage";
import { ShieldCheck, Lock, Server, UserCog, Trash2, KeyRound } from "lucide-react";

const items = [
  {icon: Lock, title:"Authenticated workspace access", body:"Every workspace requires authentication. Members are scoped to workspaces they belong to."},
  {icon: Server, title:"Private document storage", body:"Business documents are stored privately by default and served through authenticated endpoints."},
  {icon: UserCog, title:"Role-based access", body:"Owner, administrator, editor and viewer roles determine who can create, edit and manage content."},
  {icon: ShieldCheck, title:"Server-side processing", body:"All document generation is performed server-side. AI provider keys are never exposed to browsers."},
  {icon: KeyRound, title:"Server-side secrets", body:"API keys and secrets live in server environment configuration, not in code or client bundles."},
  {icon: Trash2, title:"User-controlled deletion", body:"Owners can permanently delete workspace data. Documents and templates support archive."},
];

export default function Security() {
  return (
    <MarketingPage eyebrow="Security" title="Serious about your documentation. Serious about protecting it." subtitle="Fexidoc is designed as a controlled documentation environment for engineering and industrial businesses.">
      <div className="grid md:grid-cols-2 gap-4">
        {items.map((s) => (
          <div key={s.title} className="fx-panel p-6">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan-500/20 to-violet-500/20 flex items-center justify-center border border-cyan-400/20 mb-4"><s.icon size={18} className="text-cyan-300"/></div>
            <div className="font-display font-semibold text-slate-100">{s.title}</div>
            <div className="text-slate-400 text-sm mt-2 leading-relaxed">{s.body}</div>
          </div>
        ))}
      </div>
      <div className="fx-panel p-6 mt-8 border-amber-500/30">
        <div className="text-sm text-slate-300 leading-relaxed">Fexidoc structures information supplied by your organisation. Technical, safety and compliance content should be reviewed by an appropriately authorised person before use.</div>
      </div>
    </MarketingPage>
  );
}
